import api from './api';

export const suiviAPI = {
  getSuivis: (dossierId) => api.get(`/suivi/${dossierId}`),
  createSuivi: (data) => api.post('/suivi', data),
  getCommentaires: (dossierId) => api.get(`/suivi/commentaires/${dossierId}`),
  createCommentaire: (data) => api.post('/suivi/commentaires', data),
  deleteCommentaire: (id) => api.delete(`/suivi/commentaires/${id}`)
};
